<template>
  <div class="modal filter-modal promt-create-modal offer-modal accept-offer">
    <div class="overlay" @click="$emit('close')"></div>
    <div class="wrapper">
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="bottom">
                <div class="title small">{{ $t("Payment details") }}</div>
                <div class="desc">{{ $t("Account holder") }}</div>
                <input
                  type="text"
                  v-model="full_name"
                  :placeholder="$t('Full name')"
                />
                <div class="desc">{{ $t("Bank account") }}</div>
                <input
                  type="text"
                  v-model="iban"
                  :placeholder="$t('IBAN number')"
                />
                <div class="cta-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="title">{{ $t("I agree with") }} </span>
                        <a @click="goToPrivacy" class="title">
                          {{ $t("privacy policy") }}</a
                        >
                        <span class="title"> {{ $t("and") }} </span>
                        <a @click="goToTerms" class="title">{{
                          $t("terms and conditions")
                        }}</a>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <transition name="slide">
                <div v-if="error || localError" class="error-desc desc red">{{ localError || error }}</div>
              </transition>
              <div class="buttons">
                <button
                  :class="[
                    'button blue',
                    { disabled: !requiredFieldsAreFilled },
                  ]"
                  @click="confirm"
                >
                  <span>{{ $t("Confirm") }}</span>
                </button>
                <button class="button" @click="$emit('back')">
                  {{ $t("Back") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentSepaModal",
  props: {
    error: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      full_name: "",
      iban: "",
      terms: false,
      localError: "",
    };
  },
  computed: {
    isFullNameTwoWords() {
      const parts = String(this.full_name || "").trim().split(/\s+/).filter(Boolean);
      return parts.length >= 2;
    },
    requiredFieldsAreFilled() {
      return this.isFullNameTwoWords && this.iban && this.terms;
    },
  },
  methods: {
    goToTerms() {
      this.$emit('goToTerms');
    },
    goToPrivacy() {
      this.$emit('goToPrivacy');
    },
    confirm() {
      this.localError = "";
      if (!this.requiredFieldsAreFilled) {
        if (!this.isFullNameTwoWords) {
          this.localError = this.$t("Please enter your full name (at least two words)");
        }
        return;
      }

      this.$emit("confirm", {
        full_name: this.full_name,
        iban: this.iban,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.desc {
  font-size: 18px;
  font-weight: 700;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
